export const COLORS = {
  // Cores Primárias
  primary: "#1A535C",
  primaryLight: "#24737F",
  primaryLighter: "#2E93A3",

  // Cores de Estado
  success: "#1DB954",
  successLight: "#34D399",

  accent: "#F5C642",
  accentLight: "#FCD34D",

  info: "#53B2FF",
  infoLight: "#6EBDFF",

  warning: "#FFB347",
  warningLight: "#FED7AA",

  error: "#EF4444",
  errorLight: "#F87171",

  // Cores Neutras - Texto
  textPrimary: "#334155",
  textSecondary: "#64748B",
  textTertiary: "#94A3B8",
  textQuaternary: "#B9C2D0",

  textDarkPrimary: "#F8FAFC",
  textDarkSecondary: "#E2E8F0",
  textDarkTertiary: "#D3DAE3",
  textDarkQuaternary: "#B9C0C9",

  // Cores Neutras - Fundos
  surface: "#FAFAFA",
  background: "#FFFFFF",
  backgroundDark: "#061E1B",
  drawer: "#e1f6f7",

  // Cores Neutras - Bordas
  border: "#E2E8F0",
  borderDark: "#CBD5E1",
};

export const VUETIFY_THEME = {
  light: {
    // Cores Primárias
    primary: COLORS.primary,
    primaryLight: COLORS.primaryLight,
    primaryLighter: COLORS.primaryLighter,

    // Cores de Estado
    secondary: COLORS.success,
    secondaryLight: COLORS.successLight,
    accent: COLORS.accent,
    accentLight: COLORS.accentLight,
    success: COLORS.success,
    successLight: COLORS.successLight,
    info: COLORS.info,
    infoLight: COLORS.infoLight,
    warning: COLORS.warning,
    warningLight: COLORS.warningLight,
    error: COLORS.error,
    errorLight: COLORS.errorLight,

    // Cores Neutras - Texto
    textPrimary: COLORS.textPrimary,
    textSecondary: COLORS.textSecondary,
    textTertiary: COLORS.textTertiary,
    textQuaternary: COLORS.textQuaternary,

    textDarkPrimary: COLORS.textDarkPrimary,
    textDarkSecondary: COLORS.textDarkSecondary,
    textDarkTertiary: COLORS.textDarkTertiary,
    textDarkQuaternary: COLORS.textDarkQuaternary,

    // Cores Neutras - Fundos
    surface: COLORS.surface,
    background: COLORS.background,
    backgroundDark: COLORS.backgroundDark,
    drawer: COLORS.drawer,

    // Cores Neutras - Bordas
    border: COLORS.border,
    borderDark: COLORS.borderDark,
  },
};

export default COLORS;
